export default __webpack_public_path__ + "static/media/teacher.2c4a65ca.png";